import React from 'react'
import Categories from '../Components/Sections/Categories';
import About from '../Components/Sections/About';
import OurMenu from '../Components/Sections/OurMenu';
import Video from '../Components/Sections/Video';
import Team from '../Components/Sections/Team';
import FeedBack from '../Components/Sections/FeedBack';
import BlogPost from '../Components/Sections/BlogPost';
import HeroSection2 from '../Components/Sections/HeroSection2';
const Home2 = () => {
    return (
        <>
            <HeroSection2 />
            <Categories />
            <About />
            <OurMenu />
            <Video />
            <Team />
            <FeedBack />
            <BlogPost />
        </>
    )
}

export default Home2
